import { Component, OnInit, Input, AfterContentInit, OnChanges, SimpleChanges} from '@angular/core';
import { Categoria } from 'my-lib-sanfelici';
import { Cataloghi } from 'my-lib-sanfelici';
import { CataloghiService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-cataloghi-combo',
  templateUrl: './cataloghi-combo.component.html',
  styleUrls: ['./cataloghi-combo.component.css']
})
export class CataloghiComboComponent implements OnInit, OnChanges {
    @Input() categoria: Categoria;
    catalogo: Cataloghi;

    cataloghi: Array<Cataloghi>;


    constructor(private cataloghiservice: CataloghiService) { }
    ngOnChanges(changes: SimpleChanges ) {
        if (changes.categoria.currentValue && !changes.categoria.firstChange) {
           this.categoria = changes.categoria.currentValue;
        }
    }
  ngOnInit() {
      this.cataloghiservice.list();


  }

}
